/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UUID } from '../models/UUID';
import type { ViewRequest } from '../models/ViewRequest';
import type { ViewResponse } from '../models/ViewResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ViewResourceService {

    /**
     * Creates a view
     * @param namespaceId
     * @param requestBody View object to create
     * @returns ViewResponse The requested view
     * @throws ApiError
     */
    public static createView(
        namespaceId: UUID,
        requestBody: ViewRequest,
    ): CancelablePromise<ViewResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/namespaces/{namespaceId}/views',
            path: {
                'namespaceId': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Gets a view
     * @param id
     * @param namespaceId
     * @returns ViewResponse The requested view
     * @throws ApiError
     */
    public static getView(
        id: UUID,
        namespaceId: UUID,
    ): CancelablePromise<ViewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/namespaces/{namespaceId}/views/{id}',
            path: {
                'id': id,
                'namespaceId': namespaceId,
            },
        });
    }

    /**
     * Updates a view's metadata
     * @param id
     * @param namespaceId
     * @param requestBody View object to update
     * @returns ViewResponse The updated view
     * @throws ApiError
     */
    public static updateView(
        id: UUID,
        namespaceId: UUID,
        requestBody: ViewRequest,
    ): CancelablePromise<ViewResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/namespaces/{namespaceId}/views/{id}',
            path: {
                'id': id,
                'namespaceId': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Deletes a view
     * @param id
     * @param namespaceId
     * @returns any 200 if the view was deleted properly
     * @throws ApiError
     */
    public static deleteView(
        id: UUID,
        namespaceId: UUID,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/namespaces/{namespaceId}/views/{id}',
            path: {
                'id': id,
                'namespaceId': namespaceId,
            },
        });
    }

}
